import AppEula from './AppEula';

export default AppEula;